<script lang="ts">
import FindCompanyEconomicSectorOptions from "@/Components/FindCompany/FindCompanyEconomicSectorOptions.vue";
import FindCompanySkills from "@/Components/FindCompany/FindCompanySkills.vue";
import GenericButton from "@/Components/Generics/GenericButton.vue";
import MainPage from "@/Components/MainPage.vue";
import { EconomicSectors, QualificationInput, QualificationsGroups, SelectedEconomicSectorIds } from "@/Types";
import { defineComponent, PropType } from "vue";

export default defineComponent({
    components: {
        MainPage,
        FindCompanyEconomicSectorOptions,
        FindCompanySkills,
        GenericButton,
    },
    props: {
        searchingProcess: {
            type: Boolean,
            default: false,
        },

        economicSectors: {
            type: Array as PropType<EconomicSectors>,
            required: true,
        },
        selectedEconomicSectors: {
            type: Array as PropType<SelectedEconomicSectorIds>,
            required: true,
        },

        qualificationGroups: {
            type: Array as PropType<QualificationsGroups>,
            required: true,
        },
        qualificationInput: {
            type: Array as PropType<QualificationInput>,
            required: true,
        },
    },
    emits: ["economicSectorValueChanged", "qualificationValueChanged", "clickFindCompany"],
    data: () => ({}),
    computed: {},
    methods: {},
});
</script>

<template>
    <MainPage :title="$trans('navigation.nav_find')" :title-id="'startOfJobfuchs'">
        <div class="page-section flex flex--width flex--v flex--valign-c flex--gap-50">
            <!-- SKILLS TITLE -->
            <div class="flex flex--v flex--valign-c flex--gap-10">
                <span class="text text--primary-gradient text--bold text--size-30">
                    {{ $trans("main.find-skills-headline") }}
                </span>
                <span class="text text--accent-gray-b text--medium text--size-20 text--less-gap text--center">
                    {{ $trans("main.find-skills-subheadline") }}
                </span>
            </div>

            <!-- SKILLS CONTENT -->
            <FindCompanySkills :qualification-groups="qualificationGroups" :qualification-input="qualificationInput" @qualification-value-changed="(qualificationId, value) => $emit('qualificationValueChanged', qualificationId, value)" />
        </div>

        <div class="page-section flex flex--v flex--valign-c flex--gap-50">
            <!-- CHOOSE TITLE -->
            <div class="flex flex--v flex--valign-c flex--gap-10">
                <span class="text text--primary-gradient text--bold text--size-30">
                    {{ $trans("main.find-choose-headline") }}
                </span>
                <span class="text text--accent-gray-b text--medium text--size-20 text--less-gap text--center">
                    {{ $trans("main.find-choose-subheadline") }}
                </span>
            </div>

            <!-- CHOOSE CONTENT -->
            <FindCompanyEconomicSectorOptions :sectors="economicSectors" :selected-sectors="selectedEconomicSectors" @sector-value-changed="(value) => $emit('economicSectorValueChanged', value)" />
        </div>

        <div id="startOfFindCompany" class="flex flex--v fkex--valign-c">
            <GenericButton :title="$trans('search.btn_search')" :identifier="'djf_update_search'" :searching="searchingProcess" :omit-icon-when-s-m="false" @click="$emit('clickFindCompany')" />
        </div>
    </MainPage>
</template>

<style lang="scss" scoped>
@include media-breakpoint-down(lg) {
    .page-section {
        gap: rem(45);
    }
}
@include media-breakpoint-down(md) {
    .page-section {
        gap: rem(35);
    }
}
@include media-breakpoint-down(sm) {
    .page-section {
        gap: rem(25);
    }
}
</style>
